import { useRef, useState } from "react";
import { logoutUser, setLoggingOut } from "../redux/features/userAuth/userAuth";
import { useAppDispatch, useAppSelector } from "../redux/app/hooks";
import { useNavigate, useParams } from "react-router-dom";
import { Cookies, useCookies } from "react-cookie";
import { distributorlogout } from "../redux/features/distributoreCatalogue/distributoreCatalogue";
import ModalComponent from "../components/ModalComponent";
import ButtonComponent from "../components/ButtonComponent";
import { useOnClickOutside } from "../hooks/useOnClickOutside";
import { ChevronDown, Phone, LogOut, ShoppingCart } from "lucide-react";

type Props = {};

const ProfileDropDown = (props: Props) => {
  const [isOpen, setIsOpen] = useState(false);
  const [deleteModal, setDeleteModal] = useState<boolean>(false);

  const ref: any = useRef(null);
  useOnClickOutside(ref, () => setIsOpen(false));

  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const [cookies] = useCookies(["type"]);

  const Modalref = useRef<HTMLDivElement | null>(null);
  useOnClickOutside(Modalref, () => setIsOpen(false));

  const { id } = useParams();

  const name = localStorage.getItem("name");
  const Number = localStorage.getItem("number");
  const leadCartSummary = useAppSelector((state) => state.leadUserCart.summary);
  const distributorCartSummary = useAppSelector((state) => state.distributoreCart.summary);
  const cartSummary = cookies.type === "1" ? distributorCartSummary : leadCartSummary;

  // Get initials for avatar
  const getInitials = (name: string | null) => {
    if (!name) return "U";
    return name
      .split(" ")
      .map((word) => word.charAt(0))
      .join("")
      .toUpperCase()
      .slice(0, 2);
  };

  function handleLogout() {
    setDeleteModal(true);
  }

  function handlelogout() {
    dispatch(setLoggingOut(true));
    if (cookies.type === "0") {
      dispatch(logoutUser()).then(() => {
        const Cookiess = new Cookies();
        Cookiess.remove("refreshToken", { path: "/" });
        Cookiess.remove("authToken", { path: "/" });
        Cookiess.remove("type", { path: "/" });
        Cookiess.remove("is_readOnly", { path: "/" });
        localStorage.clear();
        navigate(`/login?id=${id}`);
      });
    } else {
      dispatch(distributorlogout({})).then(() => {
        const Cookiess = new Cookies();
        Cookiess.remove("refreshToken", { path: "/" });
        Cookiess.remove("authToken", { path: "/" });
        Cookiess.remove("type", { path: "/" });
        Cookiess.remove("is_readOnly", { path: "/" });
        localStorage.clear();
        navigate(`/?id=${id}`);
      });
    }
  }
  return (
    <>
      {deleteModal ? (
        <ModalComponent setShow={setDeleteModal} show={deleteModal}>
          <div className="flex flex-col h-full  ">
            <div className="text-primary font-bold px-6 py-4 border-b flex flex-row justify-between">
              Logout
              <h1 className="text-lg font-bold cursor-pointer" onClick={() => setDeleteModal(false)}>
                X
              </h1>
            </div>
            <div className="min-h-[3rem] px-6 py-2">Are you sure for Logout?</div>
            <div className="flex flex-row justify-between px-6 gap-7 py-5">
              <ButtonComponent variant="dynamic" CTA="Cancel" onClick={() => setDeleteModal(false)} />
              <ButtonComponent variant="primary" CTA="Log-Out" onClick={() => handlelogout()} />
            </div>
          </div>
        </ModalComponent>
      ) : null}
      <div className="relative" ref={Modalref}>
        {/* Profile Header */}
        <div className="flex items-center gap-3 cursor-pointer hover:bg-gray-50 rounded-lg p-2 transition-colors" onClick={() => setIsOpen((prev) => !prev)}>
          {/* Avatar */}
          <div className="w-10 h-10 background-primary rounded-full flex items-center justify-center text-white font-semibold text-sm">{getInitials(name)}</div>

          {/* Name */}
          <span className="font-medium text-gray-900 hidden md:block">{name || "User"}</span>

          {/* Cart icon (next to name) */}
          <button
            type="button"
            onClick={(e) => {
              e.stopPropagation();
              const to = cookies.type === "1" ? `/distributor/${id}/order-cart` : `/catalogues/${id}/order-cart`;
              navigate(to);
            }}
            className="relative inline-flex items-center justify-center w-9 h-9 rounded-lg hover:bg-gray-100 transition-colors"
            aria-label="Open cart"
          >
            <ShoppingCart className="w-5 h-5 text-gray-700" />
            {(cartSummary?.total_qty ?? 0) > 0 && (
              <span className="absolute -top-1 -right-1 bg-red-500 text-white text-[10px] rounded-full h-4 min-w-4 px-1 flex items-center justify-center font-bold">
                {cartSummary.total_qty}
              </span>
            )}
          </button>

          {/* Chevron */}
          <ChevronDown className={`w-4 h-4 text-gray-500 transition-transform duration-200 ${isOpen ? "rotate-180" : ""}`} />
        </div>

        {/* Dropdown Menu */}
        {isOpen && (
          <div className="absolute right-0 top-12 bg-white rounded-xl shadow-lg border border-gray-200 py-2 z-50 min-w-fit">
            {/* Phone Number Item */}
            <div className="flex items-center gap-3 px-4 py-3 hover:bg-gray-50 transition-colors whitespace-nowrap">
              <Phone className="w-5 h-5 text-blue-600 flex-shrink-0" />
              <span className="text-blue-600 font-medium">{Number || "No number"}</span>
            </div>

            {/* Logout Item */}
            <div className="flex items-center gap-3 px-4 py-3 hover:bg-gray-50 transition-colors cursor-pointer whitespace-nowrap" onClick={handleLogout}>
              <LogOut className="w-5 h-5 text-red-600 flex-shrink-0" />
              <span className="text-red-600 font-medium">Logout</span>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default ProfileDropDown;
